import React, { useEffect } from 'react'
import { StepProps } from '../../../../components/_WMS/Stepper'
import { eInventoryCheckSteps, SharedStateType } from '../../types'
import { Box, Typography } from '@mui/material'
import { stepperStyles } from '../styles'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import PulsingIcon from '../../../../components/_WMS/_icons/PulsingIcon'

interface SuccessInventoryCheckProps extends StepProps<SharedStateType> {}

export const SuccessInventoryCheck: React.FC<SuccessInventoryCheckProps> = ({
  goToStep,
  sharedState: { positionCode }
}) => {
    
  const handleContinue = () => {
    goToStep(eInventoryCheckSteps.ShowInventoryCheckPositions)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      handleContinue()
    }, 3000) 
    
    return () => clearTimeout(timer)
  }, [goToStep])

  return (
    <Box
      sx={{
        ...stepperStyles.root,
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >

      <Box
        sx={{
          ...stepperStyles.content,
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          px: 3
        }}
      >
        <Box
          sx={{
            width: 220,
            height: 220,
            borderRadius: '50%',
            background:
              'radial-gradient(circle, rgba(141,167,80,0.18) 0%, rgba(141,167,80,0) 72%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 4,
            mx: 'auto',
            overflow: 'visible'
          }}
        >
          <Box sx={{ fontSize: '96px' }}>
            <PulsingIcon
              maxScale={3}
              duration='1.8s'
              IconComponent={CheckCircleOutlineIcon}
              color='#8DA750'
              initialColor='#2d5a1b'
              finalColor='#8DA750'
              fontSize='inherit'
            />
          </Box>
        </Box>

        <Typography
          variant='h5'
          sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}
        >
          ¡Finalizada con éxito!
        </Typography>

        <Typography variant='body1' sx={{ color: 'text.secondary' }}>
          La posición{' '}
          <Box
            component='span'
            sx={{ fontWeight: 700, color: 'text.primary' }}
          >
            {positionCode}
          </Box>{' '}
          ha sido procesada correctamente.
        </Typography>
      </Box>
      
    </Box>
  )
}